import maplibregl from 'maplibre-gl'

export const ROUTE_ARROW_IMAGE_ID = 'route-arrow'

function createArrowImageData(size: number): { data: Uint8Array, width: number, height: number } {
    const canvas = document.createElement('canvas')
    canvas.width = size
    canvas.height = size
    const ctx = canvas.getContext('2d')!
    ctx.lineCap = 'round'
    ctx.lineJoin = 'round'
    // Right-pointing chevron; symbol-placement:'line' auto-rotates it to follow the path
    ctx.beginPath()
    ctx.moveTo(size * 0.22, size * 0.17)
    ctx.lineTo(size * 0.73, size * 0.5)
    ctx.lineTo(size * 0.22, size * 0.83)
    ctx.strokeStyle = 'rgba(0, 0, 0, 0.5)'
    ctx.lineWidth = size * 0.22
    ctx.stroke()
    const { data } = ctx.getImageData(0, 0, size, size)
    return { data: new Uint8Array(data.buffer), width: size, height: size }
}

export function ensureRouteArrowImage(map: maplibregl.Map): void {
    if (!map.hasImage(ROUTE_ARROW_IMAGE_ID)) {
        map.addImage(ROUTE_ARROW_IMAGE_ID, createArrowImageData(20))
    }
}
